import React, { useState } from "react";
import "./CustomTabsStyle.scss";
import { motion, AnimatePresence } from "framer-motion";
import {
  PrevButton,
  NextButton,
  usePrevNextButtons,
} from "../EmblaArrowButtons";
import useEmblaCarousel from "embla-carousel-react";
import CustomButton from "../CustomButton";

const contentVariants = {
  initial: { scale: 0.8, opacity: 0, y: -30 },
  animate: { scale: 1, opacity: 1, y: 0 },
  exit: { scale: 1, opacity: 0, y: 30 },
};

function CustomTabs({ tabs }) {
  const [activeTab, setActiveTab] = useState(0);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    slidesToScroll: "auto",
    align: "start",
  });

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <div className="custom-tabs-wrap">
      <div className="custom-tabs-box">
        <div className="embla">
          {!prevBtnDisabled && (
            <PrevButton
              onClick={onPrevButtonClick}
              disabled={prevBtnDisabled}
            />
          )}
          <div className="embla__viewport" ref={emblaRef}>
            <div className="embla__container">
              {tabs.map((tab, index) => (
                <div className="embla__slide" key={index}>
                  <CustomButton
                    onClick={() => setActiveTab(index)}
                    className={`custom-tab-btn ${
                      activeTab === index ? "active" : ""
                    }`}
                  >
                    {tab.label}
                  </CustomButton>
                </div>
              ))}
            </div>
          </div>
          {!nextBtnDisabled && (
            <NextButton
              onClick={onNextButtonClick}
              disabled={nextBtnDisabled}
            />
          )}
        </div>
      </div>

      <div className="custom-tabs-content-box">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            className="animated-content-box"
            variants={contentVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{
              duration: 0.4,
              type: "spring",
              bounce: 0.5,
            }}
          >
            {tabs[activeTab].content}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}

export default CustomTabs;
